module.exports = __webpack_public_path__ + "14-o1.jpg?0a7631a63f270d3c54bfb382266b92e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/14-o1.jpg
// module id = 626
// module chunks = 0